import React, { useCallback, useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import "react-toastify/dist/ReactToastify.css";
import {
  ServicesAddHeader,
  ServicesClientHeaders,
  servicesExcelExportHeader,
  ServicesHeaders,
  ServicesHeadersData,
} from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import MainPopup from "../popup-containers/MainPopup";
import DropDown from "../ReusableComponents/DropDown";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import * as XLSX from "sheetjs-style";
import MultiSelect from "../ReusableComponents/MultiSelect";
import { useLocation, useNavigate } from "react-router-dom";
import AddServices from "../popup-containers/AddServices";
import IssueOfCommodity from "../popup-containers/IssueOfCommodity";
import DoctorAppoinment from "../popup-containers/DoctorAppoinment";
import GridPage from "../components/GridPage";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import toast, { Toaster } from "react-hot-toast";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { useUserCapability } from "../components/ConstantReducerProvider";
import Tooltip from "../ReusableComponents/Tooltip";
import ClientHistory from "../popup-containers/ClientHistotyPopup";
import Loader from "../ReusableComponents/Loader";

function Services() {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [notificationDesign, setNotificationDesign] = useState(false);

  const [handleGoBtn, setHandleGoBtn] = useState(false);
  const [bindServicesHistroyData, setBindServicesHistroyData] = useState([]);
  const [bindReferralDD, setBindReferralDD] = useState([]);
  const [bindServicesName, setBindServicesName] = useState([]);
  const [bindClientDatas, setBindClientDatas] = useState([]);
  const [bindServicesDatas, setBindServicesDatas] = useState([]);
  const [bindDoctorAppointmentDatas, setBindDoctorAppointmentDatas] = useState(
    []
  );
  const [bindMedicineDrugDatas, setBindMedicineDrugDatas] = useState([]);
  const [bindProvideServicesDatas, setBindProvideServicesDatas] = useState([]);
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [getBrandDatas, setGetBrandDatas] = useState([]);
  const [bindServicesAddData, setBindServicesAddData] = useState([]);
  const [bindAreaDD, setBindAreaDD] = useState([]);
  const [bindArea, setBindArea] = useState([]);
  const [bindUserSDPDD, setBindUserSDPDD] = useState([]);
  const [bindSDPDD, setBindSDPDD] = useState([]);
  const [bindProject, setBindProject] = useState([]);
  const [bindServiceCategory, setBindServiceCategory] = useState([]);
  const [getServiceSubCDatas, setGetServiceSubCDatas] = useState([]);
  const [getServicesData, setGetServicesDatas] = useState([]);
  const [bindServiceSubCategory, setBindServiceSubCategory] = useState([]);

  const [bindFPUserDD, setBindFPUserDD] = useState([
    { value: "1", label: "F.T.U. " },
    { value: "2", label: "C.U." },
  ]);
  const [bindTestResultTypeDD, setBindTestResultTypeDD] = useState([
    { value: "1", label: "+ve" },
    { value: "2", label: "-ve" },
  ]);
  const [bindTestResultType5DD, setBindTestResultType5DD] = useState([
    { value: "1", label: "nor" },
    { value: "2", label: "abn" },
  ]);
  const [bindPACServices, setBindPACServices] = useState([]);
  const [serviceDatas, setServiceData] = useState({});
  const [serviceDatas1, setServiceData1] = useState({});
  const [serviceDatas2, setServiceData2] = useState({});
  const [popupdata, setPopupdata] = useState({});
  const [upDatedTableData, setUpDatedTableData] = useState([]);

  const [servicesHistorypopUpOpen, setServicesHistorypopUpOpen] =
    useState(false);

  const [clientHistorypopUpOpen, setClientHistorypopUpOpen] = useState(false);
  const [clientHistoryPopupClear, setClientHistoryPopupClear] = useState(false);

  const bindGridData = useCallback(async (profile) => {
    if (!profile?.[0]) return; // Exit early if no user data

    const data = {
      mstOrganizationStructureId: profile[0].MstOrganizationId,
      mstBranchId: profile[0]?.MstLocationId,
      mstSdpId: profile[0]?.MstSDPId ?? 0,
      mstUserId: profile[0]?.MstUserId,
      mstRoleId: profile[0]?.MstRoleId,
    };

    try {
      const [clientResponse, servicesResponse] = await Promise.all([
        BindPostAPI([data], "ClientAPI/BindClientWeb"),
        BindPostAPI([data], "TXNServicesAPI/BindWebTXNServices"),
      ]);

      // Set Client data (only unblocked)
      setBindClientDatas(clientResponse?.data?.Table?.filter(item => !item.BlockedBy) ?? []);

      // Set Services data
      setBindServicesDatas(servicesResponse?.data?.Table ?? []);
      setBindDoctorAppointmentDatas(servicesResponse?.data?.Table1 ?? []);
      setBindMedicineDrugDatas(servicesResponse?.data?.Table2 ?? []);
      setBindProvideServicesDatas(servicesResponse?.data?.Table3 ?? []);

    } catch (err) {
      console.error("Error binding grid data:", err);
    }
  }, []);

  useEffect(() => {
    bindGridData(userProfileDatas);
  }, [userProfileDatas, bindGridData]);



  const HandleCommodities = (rowIndex) => {
    
    setCurrentData3([servicesFields.sdp, servicesFields.area]);
    setNotificationDesign(true);
    HandleCommoditiesOpen(true);
  };
  const HandleCommoditiesOpen = (isOpen) => {
    setCommoditiespopUpOpen(isOpen);
  };
  const HandleAppoinment = (rowIndex) => {
    const referredToConditions = (data) =>
      Array.isArray(data) &&
      data.some(
        (i) => i.ReferredTo == "1" || i.ReferredTo == "2" || i.ReferredTo == "3"
      );

    const servicesProvideDataCondition =
      referredToConditions(servicesProvideData);
    const servicesProvideDatasCondition =
      referredToConditions(servicesProvideDatas);

    if (servicesProvideDataCondition) {
      HandleAppoinmentOpen(true);
    } else if (servicesProvideDatasCondition) {
      HandleAppoinmentOpen(true);
    } else {
      HandleAppoinmentOpen(false);
    }
  };
  const HandleAppoinmentOpen = (isOpen) => {
    setAppoinmentpopUpOpen(isOpen);
  };

  const HandleServicesHistory = (rowIndex) => {
    handleServicesHistoryOpen(true);

    setServiceData(bindServicesHistroyData[rowIndex]);

    const doctorAppoinmentDatas = Object.values(
      bindDoctorAppointmentDatas
    ).filter(
      (item) =>
        item.TxnServicesId === bindServicesHistroyData[rowIndex].TxnServicesId
    );
    setServiceData1(doctorAppoinmentDatas);

    const servicesProvideChild = Object.values(bindProvideServicesDatas).filter(
      (item) =>
        item.TxnServicesId === bindServicesHistroyData[rowIndex].TxnServicesId
    );
    setServiceData2(servicesProvideChild[0]);

    const appointmentWithRowData = doctorAppoinmentDatas;

    let appointmentWithInfo;
    let ResultAppointmentWith = "";
    let ResultEmail = "";

    if (
      appointmentWithRowData.length > 0 &&
      appointmentWithRowData[0].AppointmentWith
    ) {
      const filteredData = getLocationDatas.filter(
        (item) =>
          item.MstLocationId === appointmentWithRowData[0].AppointmentWith
      );
      ResultAppointmentWith = filteredData[0].LocationName_en;
      ResultEmail = filteredData[0].Email;
    } else {

    }

    let ResultAppointmentDate = ""; // Default value in case of an empty array or undefined

    if (
      doctorAppoinmentDatas.length > 0 &&
      doctorAppoinmentDatas[0].AppoinmentDate
    ) {
      ResultAppointmentDate = doctorAppoinmentDatas[0].AppoinmentDate;
    } else {
    }

    const appointmentAreaRowData = doctorAppoinmentDatas;
    let appointmentAreaInfo;
    let ResultAppointmentArea = { value: "", label: "" }; // Default values

    if (
      appointmentAreaRowData.length > 0 &&
      appointmentAreaRowData[0].MstAreaId
    ) {
      appointmentAreaInfo = bindAppoinmentAreaDD.find(
        (L) =>
          parseInt(L.value) === parseInt(appointmentAreaRowData[0].MstAreaId)
      );

      ResultAppointmentArea = {
        value: appointmentAreaRowData[0].MstAreaId,
        label: appointmentAreaInfo ? appointmentAreaInfo.label : "Unknown",
      };
    } else {
    }

    var CRSFollowUpPart = bindServicesHistroyData[rowIndex].CRSFollowUp;
    const CRSFollowUpDate = CRSFollowUpPart
      ? CRSFollowUpPart.split("T")[0]
      : null;

    var ReferralFollowUpPart =
      bindServicesHistroyData[rowIndex].ReferralFollowUp;
    const ReferralFollowUpDate = ReferralFollowUpPart
      ? ReferralFollowUpPart.split("T")[0]
      : null;

    const sdpRowData = bindServicesHistroyData[rowIndex];
    const sdpInfo = bindSDPDD.find((L) => L.value === sdpRowData.MstSDPId);
    const ResultSDP = {
      value: sdpRowData.MstSDPId,
      label: sdpInfo ? sdpInfo.label : "Unknown",
    };

    const areaRowData = bindServicesHistroyData[rowIndex];
    const areaInfo = bindArea.find((A) => A.value === areaRowData.MstAreaId);
    const ResultArea = {
      value: areaRowData.MstAreaId,
      label: areaInfo ? areaInfo.label : "Unknown",
    };
    const bindTxnServicesId = bindServicesHistroyData[rowIndex].TxnServicesId;

    const serviceSubCfilteredData = Object.values(
      bindProvideServicesDatas
    ).filter((item) => item.TxnServicesId === bindTxnServicesId);
    const resultserviceSubC = serviceSubCfilteredData.map(
      (item) => item.MstServicesSubCategoryId
    );

    const serviceNamefilteredData = Object.values(
      bindProvideServicesDatas
    ).filter((item) => item.TxnServicesId === bindTxnServicesId);
    const resultservicesName = serviceNamefilteredData.map(
      (item) => item.MstServicesId
    );

    const issueMedicineDrugDatas = Object.values(bindMedicineDrugDatas).filter(
      (item) =>
        item.TxnServicesId === bindServicesHistroyData[rowIndex].TxnServicesId
    );

    setCurrentData1(issueMedicineDrugDatas);
    setCurrentData3(servicesFields.sdp, servicesFields.area);
    const ProvideServicesFilteredData = Object.values(
      bindProvideServicesDatas
    ).filter((item) => item.TxnServicesId === bindTxnServicesId);

    const servicesNameData = ProvideServicesFilteredData.map(
      (item) => item.MstServicesId
    );

    const servicesProvideDatas = Object.values(bindProvideServicesDatas).filter(
      (item) =>
        item.TxnServicesId === bindServicesHistroyData[rowIndex].TxnServicesId
    );
    let updatedTableDatas = "";
    const servicesSelectedvalue = servicesNameData;
    const servicesLabels = getServicesData.filter((item) =>
      servicesSelectedvalue.includes(item.MstServicesId)
    );

    const servicesMap = new Map(
      servicesLabels.map((service) => [service.MstServicesId, service])
    );

    const updatedTableData = servicesProvideDatas.map((data) => {
      const service = servicesMap.get(data.MstServicesId);
      const FPItemProvidedIdOptions = getBrandDatas
        .filter(
          (item) =>
            item.MstCommodityCategoryId == service.MstCommodityCategoryId
        )
        .map((items) => ({
          value: items.MstBrandId,
          label: items.Brand_en,
        }));
      if (service) {
        return {
          ...data,
          value: `${service.ServicesCategory_en}-${service.ServicesSubCategory_en}-${service.Services_en}`,
          TestResultType: service.TestResultType,
          ResultUOM: `${service.ResultUOM}`,
          TestResult: data.TestResult,
          TestResultRadio: data.TestResultRadio,
          Quantity: data.Item,
          FPItemProvidedIdOptions: FPItemProvidedIdOptions,
          MstBrandId: data.MstBrandId,
          Charges: data.Charges,
          FPUser: data.FPUser,
          ReferredTo: data.ReferredTo,
        };
      }

      return data;
    });
    setUpDatedTableData(updatedTableData);

    var Date = bindServicesHistroyData[rowIndex].ServicesDate;
    const formattedDate = Date.split("T")[0];
    const AutoDropdownPopupdata = [
      ResultAppointmentWith,
      CRSFollowUpDate,
      ReferralFollowUpDate,
      ResultSDP,
      ResultArea,
      resultserviceSubC,
      resultservicesName,
      formattedDate,
      ResultEmail,
    ];

    setPopupdata(AutoDropdownPopupdata);
  };

  const HandleClientHistory = (rowIndex) => {
    const filteredData = bindServicesDatas?.filter(
      (item) => item.ClientId == bindClientDatas[rowIndex].ClientId
    );
    if (filteredData.length != 0) {
      setClientHistoryPopupClear(false);
      handleClientHistoryOpen(true);

      setServiceData(bindClientDatas[rowIndex].ClientId);
    } else {
      setClientHistoryPopupClear(true);
      handleClientHistoryOpen(false);
      toast.error(
        `No records for this client id - ${bindClientDatas[rowIndex].ClientId}`,
        {
          position: "top-center",
          autoClose: 3000, // Duration in ms
        }
      );
    }
  };

  const handleServicesHistoryOpen = (isOpen) => {
    setServicesHistorypopUpOpen(isOpen);
  };

  const handleClientHistoryOpen = (isOpen) => {
    setClientHistorypopUpOpen(isOpen);
  };

  const handleClose = () => {
    setpopUpOpen(false);
    setAppoinmentpopUpOpen(false);
    setCommoditiespopUpOpen(false);
    setServicesHistorypopUpOpen(false);
    setClientHistorypopUpOpen(false);
  };

  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);

  const [visibleServicesAdd, setVisibleServicesAdd] = useState(false);

  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);

  const [rowIndex, setRowIndex] = useState("");

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [commoditiespopUpOpen, setCommoditiespopUpOpen] = useState(false);
  const [appoinmentpopUpOpen, setAppoinmentpopUpOpen] = useState(false);

  const [visiblePlus, setVisiblePlus] = useState(false);
  const [serviceNameChanged, setServiceNameChanged] = useState(false);

  //Value store States

  const [txnServicesId, setTxnServicesId] = useState("");
  const [serviceSubCategory, setServiceSubCategory] = useState("");
  const [servicesName, setServicesName] = useState("");
  const [serviceSubCategoryError, setServiceSubCategoryError] = useState("");
  const [servicesNameError, setServicesNameError] = useState("");
  const [editDate, setEditDate] = useState("");

  const [servicesFields, setServicesFields] = useState({
    branchId: "",
    clientId: "",

    clientGender: "",
    clientName: "",
    motherName: "",
    phoneNumber: "",
    date: new Date(),
    reasonForVisit: "",
    sdp: "",
    area: "",
    project: "",
    serviceCategory: "",
    renewalDate: "",
    referralfollowupDate: "",
    servicesRemark: "",
    charges: "",
  });
  const [servicesFieldsError, setServicesFieldsError] = useState({
    sdpError: "",
    areaError: "",
    projectError: "",
    serviceCategoryError: "",
    reasonForVisitError: "",
    servicesNameError: "",
    chargesError: "",
  });

  const [tooltipText, setTooltipText] = useState();
  const location1 = useLocation();
  const serviceAdd = location1?.state?.isAdd;

  const [addClientVisible, setAddClientVisible] = useState(true);


  const showAdd = () => {
    setIsLoading(true)
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    navigate("/clientmaster", { state: { isAddClient: true, menuId: 28 } });
    setIsLoading(false)
  };
  const location = useLocation();
  const ServicesClient = location?.state?.isServices;
  useEffect(() => {
    if (ServicesClient) {
      setAddClientVisible(true);
    }
  }, []);

  const cancel = () => {
    setTxnServicesId("")
    setHandleGoBtn(false)
    setSubmitBtnDisabled(false);
    setIsLoading(false);
    setIssuePopupCancel(true);
    setDoctorPopupCancel(true);
    handleServicesHistoryOpen(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    bindGridData(userProfileDatas);
    setVisibleServicesAdd("");
    setServicesProvideData([]);
    setServicesProvideDatas([]);
    setServicesProvideData1([]);
    setBindProvideServicesDatas([]);
    setBindServicesName();
    setBindServiceSubCategory();
    navigate("/services", {
      state: {
        menuId: 28,
      },
    });
    setpopUpOpen(false);
    setServicesFields({
      branchId: "",
      clientId: "",
      clientGender: "",
      clientName: "",
      motherName: "",
      phoneNumber: "",
      sdp: "",
      area: "",
      project: "",
      serviceCategory: "",
      renewalDate: "",
      referralfollowupDate: "",
      servicesRemark: "",
    });
    setServicesFieldsError({
      sdpError: "",
      areaError: "",
      projectError: "",
      serviceCategoryError: "",
      chargesError: "",
      reasonForVisitError: "",
    });
    setServiceSubCategoryError("");
    setServicesNameError("");

    setCurrentData1({});
    setCurrentData3([]);
    setCurrentData2("");
    setServiceSubCategory("");
    setServicesName("");
    setServiceData("");
    setServiceData1("");
    setServiceData2("");
    setPopupdata("");
    setBindServicesAddData([]);
    setIssueCommodityData([]);
  };

  const cancel1 = () => {
    setIssuePopupCancel(true);
    setDoctorPopupCancel(true);
    handleServicesHistoryOpen(false);
    setClientHistorypopUpOpen(false);
    setClientHistoryPopupClear(true);
  };

  const handleEdit = async (rowIndex) => {

    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setVisibleServicesAdd(true);
    setIssuePopupCancel(false);
    setDoctorPopupCancel(false);

    const filteredData = Object.values(bindServicesDatas).filter(
      (item) => item.ClientId === bindServicesDatas[rowIndex].ClientId
    );
    setBindServicesHistroyData(filteredData);

    const currentCRSFollowUpDate = bindServicesDatas[rowIndex].CRSFollowUp;
    const formattedCRSFollowUpDate = currentCRSFollowUpDate
      ? currentCRSFollowUpDate.split("T")[0]
      : null;

    const currentReferralFollowUpDate =
      bindServicesDatas[rowIndex].ReferralFollowUp;
    const formattedReferralFollowUpDate = currentReferralFollowUpDate
      ? currentReferralFollowUpDate.split("T")[0]
      : null;

    const bindTxnServicesId = bindServicesDatas[rowIndex].TxnServicesId;

    const ProvideServicesFilteredData = Object.values(
      bindProvideServicesDatas
    ).filter((item) => item.TxnServicesId === bindTxnServicesId);


    const servicesNameData = ProvideServicesFilteredData.map(
      (item) => item.MstServicesId
    );

    const servicesCategoryData = ProvideServicesFilteredData.map(
      (item) => item.MstServicesCategoryId
    );
    setEditDate(bindServicesDatas[rowIndex].ServicesDate);
    var Date = bindServicesDatas[rowIndex].ServicesDate;
    const formattedDate = Date.split("T")[0];
    
    setServicesFields({
      ...servicesFields,
      branchId: userProfileDatas[0]?.MstLocationId,
      clientId: bindServicesDatas[rowIndex].ClientId,
      date: formattedDate,
      reasonForVisit: bindServicesDatas[rowIndex].ReasonForVisit_en,
      clientName: bindServicesDatas[rowIndex].ClientName_en,
      motherName: bindServicesDatas[rowIndex].ClientMotherName_en,
      phoneNumber: bindServicesDatas[rowIndex].ClientPhoneNo,
      sdp: bindServicesDatas[rowIndex].MstSDPId,
      area: bindServicesDatas[rowIndex].MstAreaId,
      project: bindServicesDatas[rowIndex].MstProject,
      renewalDate: formattedCRSFollowUpDate,
      referralfollowupDate: formattedReferralFollowUpDate,
      servicesRemark: bindServicesDatas[rowIndex].Remarks_en,
    });

    setTxnServicesId(bindServicesDatas[rowIndex].TxnServicesId);

    const issueMedicineDrugDatas = Object.values(bindMedicineDrugDatas).filter(
      (item) => item.TxnServicesId === bindServicesDatas[rowIndex].TxnServicesId
    );

    setCurrentData1(issueMedicineDrugDatas);
    setCurrentData3([
      bindServicesDatas[rowIndex].MstSDPId,
      bindServicesDatas[rowIndex].MstAreaId,
      bindServicesDatas[rowIndex].ServicesId,
      2,
    ]);
    setIssueMedicineDrugDatas(issueMedicineDrugDatas);
    const doctorAppoinmentDatas = Object.values(
      bindDoctorAppointmentDatas
    ).filter(
      (item) => item.TxnServicesId === bindServicesDatas[rowIndex].TxnServicesId
    );
    setDoctorAppoinmentDatas(doctorAppoinmentDatas[0]);
    setCurrentData2(doctorAppoinmentDatas);

    const servicesProvideDatas = Object.values(bindProvideServicesDatas).filter(
      (item) => item.TxnServicesId === bindServicesDatas[rowIndex].TxnServicesId
    );

    const servicesSelectedvalue = servicesNameData;
    const servicesLabels = getServicesData.filter((item) =>
      servicesSelectedvalue.includes(item.MstServicesId)
    );

    const servicesMap = new Map(
      servicesLabels.map((service) => [service.MstServicesId, service])
    );

    const updatedTableData = servicesProvideDatas.map((data) => {
      const service = servicesMap.get(data.MstServicesId);
      const FPItemProvidedIdOptions = getBrandDatas
        .filter(
          (item) =>
            item.MstCommodityCategoryId == service.MstCommodityCategoryId
        )
        .map((items) => ({
          value: items.MstBrandId,
          label: items.Brand_en,
        }));
      if (service) {
        return {
          ...data,
          value: `${service.Services_en}`,
          TestResultType: service.TestResultType,
          UOM: service.ResultUOM,
          ResultUOM: `${service.ResultUOM}`,
          TestResult: data.TestResult,
          TestResultRadio: data.TestResultRadio,
          ItemsProvided: data.ItemsProvided,
          Quantity: data.Item,
          FPItemProvidedIdOptions: FPItemProvidedIdOptions,
          MstBrandId: data.MstBrandId,
          FPItemProvidedId: `${service.FPItemProvidedId}`,
          MstCommodityCategoryId: `${service.MstCommodityCategoryId}`,
          Charges: data.Charges,
          FPUser: data.FPUser,
          PACServices: data.PACServices,
          ReferredTo: data.ReferredTo,
          MstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
          MstUserId: userProfileDatas[0].MstUserId,
          MstRoleId: userProfileDatas[0].MstRoleId,
          MstBranchProjectId: userProfileDatas[0].MstLocationId,
          MstSDPId: bindServicesDatas[rowIndex].MstSDPId,
          MstAreaId: bindServicesDatas[rowIndex].MstAreaId,
          MstORWId:
            userProfileDatas[0].MstRoleId == 7
              ? userProfileDatas[0].MstUserId
              : 0,
          ServicesId: bindServicesDatas[rowIndex].ServicesId,
          Flag: 2,
        };
      }
      return data;
    });

    setBindServicesAddData(updatedTableData);
    setServicesProvideDatas(updatedTableData);
  };
  const goValidate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    if (!servicesFields.serviceCategory) {
      errors.serviceCategory = "Select Service Category";
    }

    if (!serviceSubCategory) {
      errors.serviceSubCategory = "Select Service Sub-Category";
    }
    if (!servicesName) {
      errors.servicesName = "Select Service";
    }

    if (servicesFields.sdp == "") {
      errors.sdp = "Select SDP";
    }

    // if (servicesFields.reasonForVisit == "") {
    //   errors.reasonForVisit = "Enter Reason For Visit";
    // }

    if (servicesFields.area == "") {
      errors.area = "Select Area";
    }

    setServiceSubCategoryError(errors.serviceSubCategory || "");
    setServicesNameError(errors.servicesName || "");
    setServicesFieldsError({
      ...servicesFieldsError,
      areaErrorerrors: errors.serviceCategory || "",
      sdpErrorerrors: errors.serviceCategory || "",
      // reasonForVisitError: errors.reasonForVisit || "",
      serviceCategoryError: errors.serviceCategory || "",
    });
    return errors;
  };

  // const HandleGo = () => {

  //   setHandleGoBtn(true)
  //   const firstNameValidation = goValidate();

  //   if (Object.keys(firstNameValidation).length === 0) {
  //     setIsLoading(true)
  //     setVisibleServicesAdd(true);

  //     if (servicesName && serviceNameChanged) {
  //       const accumulatedServices = [];

  //       // Use a for loop to iterate over servicesName
  //       for (let i = 0; i < servicesName.length; i++) {
  //         const element = servicesName[i];
  //         const newServicesProvide = bindServicesAddData.filter(
  //           (newService) => newService.MstServicesId == element
  //         );

  //         // Add the new filtered data to the accumulated array
  //         accumulatedServices.push(...newServicesProvide);
  //       }

  //       // Update the state once with the accumulated data
  //       setBindServicesAddData(accumulatedServices);

  //       const servicesSelectedvalue = servicesName;
  //       const servicesLabels = getServicesData.filter((item) =>
  //         servicesSelectedvalue.includes(item.MstServicesId)
  //       );

  //       if (servicesLabels.length > 0) {
  //         const servicesProvideName = servicesLabels.map((service, index) => {
  //           const FPItemProvidedIdOptions = getBrandDatas
  //             .filter(
  //               (item) =>
  //                 item.MstCommodityCategoryId == service.MstCommodityCategoryId
  //             )
  //             .map((items) => ({
  //               value: items.MstBrandId,
  //               label: items.Brand_en,
  //             }));

  //           return {
  //             key: `${index}`,
  //             MstServicesCategoryId: `${service.MstServicesCategoryId}`,
  //             MstServicesSubCategoryId: `${service.MstServicesSubCategoryId}`,
  //             MstServicesId: `${service.MstServicesId}`,
  //             value: `${service.Services_en}`,
  //             TestResultType: `${service.TestResultType}`,
  //             ItemsProvided: `${service.ItemsProvided}`,
  //             ResultUOM: `${service.ResultUOM}`,
  //             TestResult: "",
  //             FPItemProvidedIdOptions: FPItemProvidedIdOptions,
  //             FPItemProvidedId: `${service.FPItemProvidedId}`,
  //             MstBrandId: "",
  //             PACServices: `${service.PACServices}`,
  //             MstCommodityCategoryId: `${service.MstCommodityCategoryId}`,
  //             TestResultRadio: "",
  //             Quantity: "",
  //             Charges: "",
  //             FPUser: "",
  //             ReferredTo: "",
  //             MstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
  //             MstUserId: userProfileDatas[0].MstUserId,
  //             MstRoleId: userProfileDatas[0].MstRoleId,
  //             MstBranchProjectId: userProfileDatas[0].MstLocationId,
  //             MstSDPId: servicesFields.sdp,
  //             MstAreaId: servicesFields.area,
  //             MstORWId:
  //               userProfileDatas[0].MstRoleId == 7
  //                 ? userProfileDatas[0].MstUserId
  //                 : 0,
  //           };
  //         });

  //         const currentData = bindServicesAddData; // Assuming a getter function for current state
  //         const newServicesProvide = servicesProvideName.filter(
  //           (newService) =>
  //             !currentData.some(
  //               (existingService) =>
  //                 existingService.MstServicesId == newService.MstServicesId
  //             )
  //         );

  //         // Only update state if there are new services to add
  //         if (newServicesProvide.length > 0) {
  //           const updatedBindServicesAddData = [
  //             ...currentData,
  //             ...newServicesProvide,
  //           ];
  //           setBindServicesAddData(updatedBindServicesAddData);
  //           console.log("bindServicesAddData", bindServicesAddData)
  //         }

  //         setServicesProvideData1(servicesProvideName);
  //         setIsLoading(false)
  //       } else {
  //         setBindServicesAddData([]);
  //         setIsLoading(false)
  //       }
  //     }

  //     const filteredData = Object.values(bindServicesDatas).filter(
  //       (item) => item.ClientId === servicesFields.clientId
  //     );
  //     setBindServicesHistroyData(filteredData);
  //   }
  // };

  const HandleGo = () => {
    setHandleGoBtn(true)
    const firstNameValidation = goValidate();

    if (Object.keys(firstNameValidation).length === 0) {
      setIsLoading(true)
      setVisibleServicesAdd(true);

      if (servicesName && serviceNameChanged) {
        // ❌ removed the accumulatedServices/setBindServicesAddData reset block —
        // it was wiping the table before the merge logic below could run

        const servicesSelectedvalue = servicesName;
        const servicesLabels = getServicesData.filter((item) =>
          servicesSelectedvalue.includes(item.MstServicesId)
        );

        if (servicesLabels.length > 0) {
          const servicesProvideName = servicesLabels.map((service, index) => {
            const FPItemProvidedIdOptions = getBrandDatas
              .filter(
                (item) =>
                  item.MstCommodityCategoryId == service.MstCommodityCategoryId
              )
              .map((items) => ({
                value: items.MstBrandId,
                label: items.Brand_en,
              }));

            return {
              key: `${index}`,
              MstServicesCategoryId: `${service.MstServicesCategoryId}`,
              MstServicesSubCategoryId: `${service.MstServicesSubCategoryId}`,
              MstServicesId: `${service.MstServicesId}`,
              value: `${service.Services_en}`,
              TestResultType: `${service.TestResultType}`,
              ItemsProvided: `${service.ItemsProvided}`,
              ResultUOM: `${service.ResultUOM}`,
              TestResult: "",
              FPItemProvidedIdOptions: FPItemProvidedIdOptions,
              FPItemProvidedId: `${service.FPItemProvidedId}`,
              MstBrandId: "",
              PACServices: `${service.PACServices}`,
              MstCommodityCategoryId: `${service.MstCommodityCategoryId}`,
              TestResultRadio: "",
              Quantity: "",
              Charges: "",
              FPUser: "",
              ReferredTo: "",
              MstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
              MstUserId: userProfileDatas[0].MstUserId,
              MstRoleId: userProfileDatas[0].MstRoleId,
              MstBranchProjectId: userProfileDatas[0].MstLocationId,
              MstSDPId: servicesFields.sdp,
              MstAreaId: servicesFields.area,
              MstORWId:
                userProfileDatas[0].MstRoleId == 7
                  ? userProfileDatas[0].MstUserId
                  : 0,
            };
          });

          const currentData = bindServicesAddData; // old rows, untouched so far

          const duplicateServices = servicesProvideName.filter((newService) =>
            currentData.some(
              (existingService) =>
                existingService.MstServicesId == newService.MstServicesId
            )
          );
          const newServicesProvide = servicesProvideName.filter(
            (newService) =>
              !currentData.some(
                (existingService) =>
                  existingService.MstServicesId == newService.MstServicesId
              )
          );

          if (duplicateServices.length > 0) {
            toast.error(
              `Service already added: ${duplicateServices
                .map((s) => s.value)
                .join(", ")}`,
              {
                duration: 5000,
                position: "top-center",
              }
            );

            const duplicateIds = duplicateServices.map((s) => s.MstServicesId);

            setServicesName((prev) =>
              prev.filter((id) => !duplicateIds.includes(`${id}`))
            );
            setServiceSubCategory((prev) =>
              Array.isArray(prev)
                ? prev.filter(
                  (subCatId) =>
                    !duplicateServices.some(
                      (s) => s.MstServicesSubCategoryId == subCatId
                    )
                )
                : prev
            );
          }

          // Merge: keep old rows, add only the genuinely new ones
          if (newServicesProvide.length > 0) {
            const updatedBindServicesAddData = [
              ...currentData,
              ...newServicesProvide,
            ];
            setBindServicesAddData(updatedBindServicesAddData);
          }

          setServicesProvideData1(newServicesProvide);
          setIsLoading(false)
        } else {
          setBindServicesAddData([]);
          setIsLoading(false)
        }
      }

      const filteredData = Object.values(bindServicesDatas).filter(
        (item) => item.ClientId === servicesFields.clientId
      );
      setBindServicesHistroyData(filteredData);
    }
  };

  const createdBy = sessionStorage.getItem("createdBy");
  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    if (flag === 1 || flag === 2) {
      // Validation logic for the Youth group Id input

      // Validation logic for sdp input
      if (servicesFields.sdp == "") {
        errors.sdp = "Select SDP";
      }

      // Validation logic for the area input
      if (servicesFields.area == "") {
        errors.area = "Select Area";
      }

      // if (servicesFields.reasonForVisit == "") {
      //   errors.reasonForVisit = "Enter Reason For Visit";
      // }
    }
    setServiceSubCategoryError(errors.serviceSubCategory || "");
    setServicesNameError(errors.servicesName || "");
    setServicesFieldsError({
      ...servicesFieldsError,
      sdpError: errors.sdp || "",
      areaError: errors.area || "",
      projectError: errors.project || "",
      serviceCategoryError: errors.serviceCategory || "",
      reasonForVisitError: errors.reasonForVisit || "",
    });
    return errors;
  };

  const handleSubmit = async (items, flag) => {
    debugger
    setIsLoading(true)
    setSubmitBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const firstNameValidation = validate(flag);
      let servicesProvideValues = [];

      if (servicesProvideData.length > 0) {
        servicesProvideValues = servicesProvideData;
      } else if (servicesProvideDatas.length > 0) {
        servicesProvideValues = servicesProvideDatas;
      } else {
        servicesProvideValues = servicesProvideData1;
      }

      let doctorAppointmentDataValues;

      if (Object.keys(docterAppoinmetData).length !== 0) {
        doctorAppointmentDataValues = docterAppoinmetData;
      } else {
        doctorAppointmentDataValues = doctorAppoinmentDatas;
      }

      let issueCommodityDataValues = [];

      if (issueCommodityData.length > 0) {
        issueCommodityDataValues = issueCommodityData;
      } else {
        let transformedData = issueMedicineDrugDatas.map((item) => {
          return {
            commodity: item?.MstCommodityTypeId,
            commodityCategory: item?.MstCommodityCategoryId,
            commodityName: item?.MstCommodityId,
            brand: item?.MstBrandId,
            quantity: item?.Quantity.toString() ?? '0',
            uom: item?.UOM,
            charges: item?.Charges.toString() ?? '0',
          };
        });
        issueCommodityDataValues = JSON.stringify(transformedData);
      }

      const languageKeys = [
        "ta", // Tamil
        "hi", // Hindi
        "mr", // Marathi
        "gu", // Gujarati
        "kn", // Kannada
        "ml", // Malayalam
        "te", // Telugu
        "bn", // Bengali
        "or", // Oriya
      ];

      // const translatedReasonForVisit = []; // Create an array to store translations 
      // if (servicesFields.reasonForVisit) {
      //   for (let i of languageKeys) {
      //     const translateText = await LanguageTranslatorAPI(
      //       servicesFields.reasonForVisit,
      //       i
      //     );
      //     translatedReasonForVisit.push(
      //       translateText.data.data.translations[0].translatedText
      //     );
      //   }
      // }
      // const translatedClientName = []; // Create an array to store translations

      // for (let i of languageKeys) {
      //   const translateText = await LanguageTranslatorAPI(
      //     servicesFields.clientName,
      //     i
      //   );
      //   translatedClientName.push(
      //     translateText.data.data.translations[0].translatedText
      //   );
      // }

      // const translatedMotherName = []; // Create an array to store translations

      // for (let i of languageKeys) {
      //   const translateText = await LanguageTranslatorAPI(
      //     servicesFields.motherName,
      //     i
      //   );
      //   translatedMotherName.push(
      //     translateText.data.data.translations[0].translatedText
      //   );
      // }

      // const translatedRemarks = []; // Create an array to store translations
      // if (servicesFields.servicesRemark) {
      //   for (let i of languageKeys) {
      //     const translateText = await LanguageTranslatorAPI(
      //       servicesFields.servicesRemark,
      //       i
      //     );
      //     translatedRemarks.push(
      //       translateText.data.data.translations[0].translatedText
      //     );
      //   }
      // }

      if (Object.keys(firstNameValidation).length === 0) {
        const data = {
          txnServicesId: txnServicesId ? txnServicesId : 0,
          mstBranchProjectId: servicesFields.branchId
            ? servicesFields.branchId
            : 0,
          mstORWId:
            userProfileDatas[0].MstRoleId == 7
              ? userProfileDatas[0].MstUserId
              : null,
          mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
          mstRoleId: userProfileDatas[0].MstRoleId,
          userMstSDPId: userProfileDatas[0].MstSDPId,
          userMstAreaId: userProfileDatas[0].MstOrganizationId == 3 ? servicesFields.area : null,
          servicesDate: flag == 1 ? servicesFields.date : editDate,

          reasonForVisit_en: servicesFields.reasonForVisit,
          // reasonForVisit_ta: translatedReasonForVisit[0],
          // reasonForVisit_hi: translatedReasonForVisit[1],
          // reasonForVisit_mr: translatedReasonForVisit[2],
          // reasonForVisit_gu: translatedReasonForVisit[3],
          // reasonForVisit_kn: translatedReasonForVisit[4],
          // reasonForVisit_ml: translatedReasonForVisit[5],
          // reasonForVisit_te: translatedReasonForVisit[6],
          // reasonForVisit_bn: translatedReasonForVisit[7],
          // reasonForVisit_or: translatedReasonForVisit[8],

          reasonForVisit_ta: '',
          reasonForVisit_hi: '',
          reasonForVisit_mr: '',
          reasonForVisit_gu: '',
          reasonForVisit_kn: '',
          reasonForVisit_ml: '',
          reasonForVisit_te: '',
          reasonForVisit_bn: '',
          reasonForVisit_or: '',

          clientId: servicesFields.clientId,
          clientName_en: servicesFields.clientName,

          // clientName_ta: translatedClientName[0],
          // clientName_hi: translatedClientName[1],
          // clientName_mr: translatedClientName[2],
          // clientName_gu: translatedClientName[3],
          // clientName_kn: translatedClientName[4],
          // clientName_ml: translatedClientName[5],
          // clientName_te: translatedClientName[6],
          // clientName_bn: translatedClientName[7],
          // clientName_or: translatedClientName[8],

          clientName_ta: '',
          clientName_hi: '',
          clientName_mr: '',
          clientName_gu: '',
          clientName_kn: '',
          clientName_ml: '',
          clientName_te: '',
          clientName_bn: '',
          clientName_or: '',

          clientMotherName_en: servicesFields.motherName,

          // clientMotherName_ta: translatedMotherName[0],
          // clientMotherName_hi: translatedMotherName[1],
          // clientMotherName_mr: translatedMotherName[2],
          // clientMotherName_gu: translatedMotherName[3],
          // clientMotherName_kn: translatedMotherName[4],
          // clientMotherName_ml: translatedMotherName[5],
          // clientMotherName_te: translatedMotherName[6],
          // clientMotherName_bn: translatedMotherName[7],
          // clientMotherName_or: translatedMotherName[8],

          clientMotherName_ta: '',
          clientMotherName_hi: '',
          clientMotherName_mr: '',
          clientMotherName_gu: '',
          clientMotherName_kn: '',
          clientMotherName_ml: '',
          clientMotherName_te: '',
          clientMotherName_bn: '',
          clientMotherName_or: '',

          clientPhoneNo: servicesFields.phoneNumber,
          mstSDPId: servicesFields.sdp,
          mstAreaId: servicesFields.area,
          mstProject: servicesFields.project ? servicesFields.project : null,
          CRSFollowUp:
            servicesFields.renewalDate &&
              servicesFields.renewalDate.trim() !== ""
              ? new Date(servicesFields.renewalDate)
              : null,

          ReferralFollowUp:
            servicesFields.referralfollowupDate &&
              servicesFields.referralfollowupDate.trim() !== ""
              ? new Date(servicesFields.referralfollowupDate)
              : null,

          remarks_en: servicesFields.servicesRemark,
          // remarks_ta: translatedRemarks[0],
          // remarks_hi: translatedRemarks[1],
          // remarks_mr: translatedRemarks[2],
          // remarks_gu: translatedRemarks[3],
          // remarks_kn: translatedRemarks[4],
          // remarks_ml: translatedRemarks[5],
          // remarks_te: translatedRemarks[6],
          // remarks_bn: translatedRemarks[7],
          // remarks_or: translatedRemarks[8],

          remarks_ta: '',
          remarks_hi: '',
          remarks_mr: '',
          remarks_gu: '',
          remarks_kn: '',
          remarks_ml: '',
          remarks_te: '',
          remarks_bn: '',
          remarks_or: '',

          servicesProvide: JSON.stringify(servicesProvideValues),

          servicesMedicineDrugs: issueCommodityDataValues,

          servicesDoctor: JSON.stringify(doctorAppointmentDataValues),

          createdBy: createdBy,
          flag: flag,
        };

        const response = await IUDAPI([data], "TXNServicesAPI/IUDTXNServices");
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].Result === "S") {
            toast.success("Services data added successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Services data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "U") {
            toast.success("Services data updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Services data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false)
      }
    } else {
      let servicesProvideValues = [];

      if (servicesProvideData.length > 0) {
        servicesProvideValues = servicesProvideData;
      } else if (servicesProvideDatas.length > 0) {
        servicesProvideValues = servicesProvideDatas;
      } else {
        servicesProvideValues = servicesProvideData1;
      }
      let issueCommodityDataValues = [];

      if (issueCommodityData.length > 0) {
        issueCommodityDataValues = issueCommodityData;
      } else {
        let transformedData = issueMedicineDrugDatas.map((item) => {
          return {
            commodity: item.MstCommodityTypeId,
            commodityCategory: item.MstCommodityCategoryId,
            commodityName: item.MstCommodityId,
            brand: item.MstBrandId,
            quantity: item.Quantity.toString(),
            uom: item.UOM,
            charges: item.Charges.toString(),
          };
        });

        issueCommodityDataValues = JSON.stringify(transformedData);
      }
      const data = {
        txnServicesId: bindServicesDatas[rowIndex].TxnServicesId,
        mstBranchProjectId: servicesFields.branchId
          ? servicesFields.branchId
          : 0,
        mstORWId:
          userProfileDatas[0].MstRoleId == 7
            ? userProfileDatas[0].MstUserId
            : null,
        mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
        mstRoleId: userProfileDatas[0].MstRoleId,
        servicesDate: flag == 1 ? servicesFields.date : editDate,
        mstSDPId: servicesFields.sdp,
        mstAreaId: servicesFields.area,
        CRSFollowUp:
          servicesFields.renewalDate &&
            servicesFields.renewalDate.trim() !== ""
            ? new Date(servicesFields.renewalDate)
            : null,

        ReferralFollowUp:
          servicesFields.referralfollowupDate &&
            servicesFields.referralfollowupDate.trim() !== ""
            ? new Date(servicesFields.referralfollowupDate)
            : null,
        servicesProvide: JSON.stringify(servicesProvideValues),
        servicesMedicineDrugs: issueCommodityDataValues,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "TXNServicesAPI/IUDTXNServices");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Services data deleted successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to delete Services data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Services data blocked successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to block Services data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Services data unblocked successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to unblock Services data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };


  const HandleDelete = (rowIndex) => {
    if (bindServicesAddData.length != 1) {
      const updatedTableData = bindServicesAddData.filter(
        (_, index) => index !== rowIndex
      );

      setBindServicesAddData(updatedTableData);

    }
  };

  const handleReferralChange = (rowIndex) => { };

  const navigate = useNavigate();

  const serviceLocation = useLocation();

  const handleServicesFieldsChange = (value, name) => {
    setServicesFields({
      ...servicesFields,
      [name]: value,
    });
  };

  const servicesSubCategoryChange = (updatedOptions) => {

    setServicesName("");
    setServiceSubCategory(updatedOptions);
  };
  const servicesNameChange = (updatedOptions) => {
    setHandleGoBtn(false)
    setServicesName(updatedOptions);
    setServiceNameChanged(true);
  };


  const fetchAllDropdowns = useCallback(async () => {
    setIsLoading(true);
    try {
      // 🔹 Run APIs in parallel
      const [locationRes, pacServicesRes] = await Promise.all([
        BindAPI("TXNServicesAPI/ServicesDatas"),
        BindAPI("ServicesMasterAPI/BindServicesDropDowns"),
      ]);

      const locData = locationRes.data || {};
      const pacData = pacServicesRes.data || {};

      // 🔹 Extract tables once
      const tables = {
        location: locData.Table2 ?? [],
        area: locData.Table ?? [],
        brand: locData.Table6 ?? [],
        serviceSub: locData.Table5 ?? [],
        services: locData.Table9 ?? [],
        project: locData.Table3 ?? [],
        serviceCategory: locData.Table4 ?? [],
        referredTo: locData.Table8 ?? [],
        pacServices: pacData.Table1 ?? [],
        appointmentWith: locData.Table1 ?? [],
      };

      // 🔹 Filter project by MstBranchProjectId & user organization
      const userOrgId = userProfileDatas[0]?.MstLocationId;

      tables.project = tables.project.filter(
        (item) => item.MstBranchProjectId === userOrgId
      );

      // 🔹 Reusable mapper
      const toOptions = (arr = [], valueKey, labelKey, { filterBlocked = false } = {}) =>
        arr
          .filter(item => !filterBlocked || item.BlockedBy == null)
          .map(item => ({ value: item[valueKey], label: item[labelKey] }));

      // 🔹 Prepare dropdowns
      const dropdowns = {
        bindSDPDD: toOptions(tables.appointmentWith, "MstSDPId", "SDP_en"),
        bindArea: toOptions(tables.area, "MstAreaId", "AreaName_en"),
        bindProject: toOptions(tables.project, "MstProjectId", "ProjectName_en"),
        bindServiceCategory: toOptions(
          tables.serviceCategory,
          "MstServicesCategoryId",
          "ServicesCategory_en"
        ),
        bindReferralDD: toOptions(tables.referredTo, "MstReferredToId", "ReferredTo_en"),
        bindPACServices: toOptions(tables.pacServices, "MstPACServicesId", "PACServices"),
      };

      // 🔹 User-specific SDP dropdown
      const { MstSDPId: userSDPId, MstLocationId: userLocationId } = userProfileDatas[0] || {};
      dropdowns.bindUserSDPDD = tables.appointmentWith
        .filter(item =>
          userSDPId ? item.MstSDPId == userSDPId : item.MstLocationId == userLocationId
        )
        .map(item => ({ value: item.MstSDPId, label: item.SDP_en }));

      // 🔹 Update states in batch (more efficient)
      setGetLocationDatas(tables.location);
      setGetAreaDatas(tables.area);
      setGetBrandDatas(tables.brand);
      setGetServiceSubCDatas(tables.serviceSub);
      setGetServicesDatas(tables.services);

      setBindSDPDD(dropdowns.bindSDPDD);
      setBindArea(dropdowns.bindArea);
      setBindProject(dropdowns.bindProject);
      setBindServiceCategory(dropdowns.bindServiceCategory);
      setBindReferralDD(dropdowns.bindReferralDD);
      setBindPACServices(dropdowns.bindPACServices);
      setBindAppoinmentWithDD(dropdowns.bindSDPDD);
      setBindUserSDPDD(dropdowns.bindUserSDPDD);

    } catch (err) {
      console.error("Error fetching dropdown data:", err);
    } finally {
      setIsLoading(false);
    }
  }, [userProfileDatas]);



  useEffect(() => {
    // Service Add Defaults
    if (serviceAdd) {

      setVisibleAdd(true);
      setVisibleTable(false);
      setVisiblePlus(serviceAdd);
      setAddScreenTitle(true);
      setIssuePopupCancel(false);
      setDoctorPopupCancel(false);
      setCurrentData1(false);

      const rowclient = location1?.state?.isData;
      const currentDate = new Date().toISOString().split("T")[0];
      const clientFields = {
        clientId: rowclient?.ClientId ?? "",

        clientGender: rowclient?.ClientGender ?? "",
        clientName: rowclient?.ClientName_en ?? "",
        motherName: rowclient?.ClientMotherName_en ?? "",
        phoneNumber: rowclient?.ClientPhoneNo ?? "-",
        date: currentDate,
        branchId: userProfileDatas[0]?.MstLocationId,

        sdp: userProfileDatas[0]?.MstSDPId,
        //  area: rowclient?.MstAreaId ?? userProfileDatas[0]?.MstAreaId,
      };

      setServicesFields(prev => ({ ...prev, ...clientFields }));
      setCurrentData3([clientFields.sdp, servicesFields.area]);

      const maxLength = 30;
      const truncatedLabelText =
        clientFields.clientName.length > maxLength
          ? clientFields.clientName.slice(0, maxLength) + "..."
          : clientFields.clientName;
      setTooltipText(truncatedLabelText);
    }
  }, [serviceAdd]);
  // Fetch all dropdowns once on mount or when serviceAdd/userProfileDatas changes
  useEffect(() => {
    fetchAllDropdowns();
  }, [fetchAllDropdowns]);

  // Derived dropdowns based on selections
  useEffect(() => {
    // Bind Area based on selected SDP
    if (!servicesFields.sdp) return;
    const areaOptions = getAreaDatas
      .filter(item => item.MstSDPId == servicesFields.sdp)
      .map(item => ({ value: item.MstAreaId, label: item.AreaName_en }));
    setBindAreaDD(areaOptions);
  }, [servicesFields.sdp, getAreaDatas]);

  useEffect(() => {
    // Service Sub Category based on selected Category
    if (!servicesFields.serviceCategory) return setBindServiceSubCategory([]);
    const subCategoryOptions = getServiceSubCDatas
      .filter(item => item.MstServicesCategoryId == servicesFields.serviceCategory)
      .map(item => ({ value: item.MstServicesSubCategoryId, label: item.ServicesSubCategory_en }));
    setBindServiceSubCategory(subCategoryOptions);
  }, [servicesFields.serviceCategory, getServiceSubCDatas]);


  // useEffect(() => {
  //   // Services Name based on selected SubCategory
  //   if (!serviceSubCategory?.length) return setBindServicesName([]);
  //   const servicesOptions = getServicesData
  //     .filter(item => serviceSubCategory.includes(item.MstServicesSubCategoryId))
  //     .map(item => ({ value: item.MstServicesId, label: item.Services_en }));
  //   setBindServicesName(servicesOptions);
  // }, [serviceSubCategory, getServicesData]);

  const roleId = userProfileDatas[0]?.MstRoleId;
  useEffect(() => {
    // ✅ If no subcategory selected, clear and exit
    if (!serviceSubCategory?.length) {
      setBindServicesName([]);
      return;
    }

    // ✅ Filter services based on selected subcategories
    let filteredServices = getServicesData.filter(item =>
      serviceSubCategory.includes(item.MstServicesSubCategoryId)
    );

    // ✅ Further filter if roleId === 7
    if (roleId == 7) {
      filteredServices = filteredServices.filter(item => {
        const serviceProvision = item.ServiceProvision;

        if (!serviceProvision) return false;

        // Convert to string, split by commas, trim spaces
        const parts = serviceProvision.toString().split(',').map(p => p.trim());

        // Keep only if '9' is present
        return parts.includes('9');
      });
    }

    // ✅ Map final filtered data to dropdown options
    const servicesOptions = filteredServices.map(item => ({
      value: item.MstServicesId,
      label: item.Services_en,
    }));

    setBindServicesName(servicesOptions);
  }, [serviceSubCategory, getServicesData, roleId]);


  const [docterAppoinmetData, setDocterAppoinmentData] = useState([]);
  const [issueCommodityData, setIssueCommodityData] = useState([]);
  const [servicesProvideData, setServicesProvideData] = useState([]);
  const [servicesProvideData1, setServicesProvideData1] = useState([]);
  const [issueMedicineDrugDatas, setIssueMedicineDrugDatas] = useState([]);
  const [doctorAppoinmentDatas, setDoctorAppoinmentDatas] = useState();
  const [servicesProvideDatas, setServicesProvideDatas] = useState([]);
  // const [servicesProvideValues, setServicesProvideValues] = useState([]);
  const handleDoctorAppoinment = (updatedData) => {
    setDocterAppoinmentData(updatedData);
  };
  const handleIssueCommodity = (updatedData) => {
    setIssueCommodityData(updatedData);
  };
  const handleServicesProvide = (updatedData) => {

    console.log("updatedData", updatedData)
    console.log("bindServicesAddData", bindServicesAddData)
    setServicesProvideData(updatedData);
    setBindServicesAddData(updatedData)

    console.log(bindServicesAddData)
  };

  const [currentData1, setCurrentData1] = useState({});
  const [currentData2, setCurrentData2] = useState({});
  const [currentData3, setCurrentData3] = useState([]);
  const [issuePopupCancel, setIssuePopupCancel] = useState(false);
  const [doctorPopupCancel, setDoctorPopupCancel] = useState(false);
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [bindAppoinmentWithDD, setBindAppoinmentWithDD] = useState([]);
  const [bindAppoinmentAreaDD, setBindAppoinmentAreaDD] = useState([]);



  const handleServicesPopup = (rowIndex, flag) => {

    handleOpen(true);
    setDoctorPopupCancel(false);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setServiceData(bindServicesDatas[rowIndex]);
    const currentCRSFollowUpDate = bindServicesDatas[rowIndex].CRSFollowUp;
    const formattedCRSFollowUpDate = currentCRSFollowUpDate
      ? currentCRSFollowUpDate.split("T")[0]
      : null;

    const currentReferralFollowUpDate =
      bindServicesDatas[rowIndex].ReferralFollowUp;
    const formattedReferralFollowUpDate = currentReferralFollowUpDate
      ? currentReferralFollowUpDate.split("T")[0]
      : null;

    const bindTxnServicesId = bindServicesDatas[rowIndex].TxnServicesId;

    const ProvideServicesFilteredData = Object.values(
      bindProvideServicesDatas
    ).filter((item) => item.TxnServicesId === bindTxnServicesId);

    const servicesNameData = ProvideServicesFilteredData.map(
      (item) => item.MstServicesId
    );

    const servicesCategoryData = ProvideServicesFilteredData.map(
      (item) => item.MstServicesCategoryId
    );
    setEditDate(bindServicesDatas[rowIndex].ServicesDate);
    var Date = bindServicesDatas[rowIndex].ServicesDate;
    const formattedDate1 = Date.split("T")[0];
    setServicesFields({
      ...servicesFields,
      branchId: userProfileDatas[0]?.MstLocationId,
      clientId: bindServicesDatas[rowIndex].ClientId,
      date: formattedDate1,
      reasonForVisit: bindServicesDatas[rowIndex].ReasonForVisit_en,
      clientName: bindServicesDatas[rowIndex].ClientName_en,
      motherName: bindServicesDatas[rowIndex].ClientMotherName_en,
      phoneNumber: bindServicesDatas[rowIndex].ClientPhoneNo,
      sdp: bindServicesDatas[rowIndex].MstSDPId,
      area: bindServicesDatas[rowIndex].MstAreaId,
      project: bindServicesDatas[rowIndex].MstProject,
      renewalDate: formattedCRSFollowUpDate,
      referralfollowupDate: formattedReferralFollowUpDate,
      servicesRemark: bindServicesDatas[rowIndex].Remarks_en,
    });

    setTxnServicesId(bindServicesDatas[rowIndex].TxnServicesId);

    const issueMedicineDrugDatas = Object.values(bindMedicineDrugDatas).filter(
      (item) => item.TxnServicesId === bindServicesDatas[rowIndex].TxnServicesId
    );

    setCurrentData1(issueMedicineDrugDatas);
    setCurrentData3([
      bindServicesDatas[rowIndex].MstSDPId,
      bindServicesDatas[rowIndex].MstAreaId,
      bindServicesDatas[rowIndex].ServicesId,
      2,
    ]);
    setIssueMedicineDrugDatas(issueMedicineDrugDatas);
    const doctorAppoinmentDatas = Object.values(
      bindDoctorAppointmentDatas
    ).filter(
      (item) => item.TxnServicesId === bindServicesDatas[rowIndex].TxnServicesId
    );
    setDoctorAppoinmentDatas(doctorAppoinmentDatas[0]);
    setCurrentData2(doctorAppoinmentDatas);

    const servicesProvideDatas = Object.values(bindProvideServicesDatas).filter(
      (item) => item.TxnServicesId === bindServicesDatas[rowIndex].TxnServicesId
    );

    const servicesSelectedvalue = servicesNameData;
    const servicesLabels = getServicesData.filter((item) =>
      servicesSelectedvalue.includes(item.MstServicesId)
    );

    const servicesMap = new Map(
      servicesLabels.map((service) => [service.MstServicesId, service])
    );

    const updatedTableData = servicesProvideDatas.map((data) => {
      const service = servicesMap.get(data.MstServicesId);
      const FPItemProvidedIdOptions = getBrandDatas
        .filter(
          (item) =>
            item.MstCommodityCategoryId == service.MstCommodityCategoryId
        )
        .map((items) => ({
          value: items.MstBrandId,
          label: items.Brand_en,
        }));
      if (service) {
        return {
          ...data,
          value: `${service.Services_en}`,
          TestResultType: service.TestResultType,
          UOM: service.ResultUOM,
          ResultUOM: `${service.ResultUOM}`,
          TestResult: data.TestResult,
          TestResultRadio: data.TestResultRadio,
          ItemsProvided: data.ItemsProvided,
          Quantity: data.Item,
          FPItemProvidedIdOptions: FPItemProvidedIdOptions,
          MstBrandId: data.MstBrandId,
          FPItemProvidedId: `${service.FPItemProvidedId}`,
          MstCommodityCategoryId: `${service.MstCommodityCategoryId}`,
          Charges: data.Charges,
          FPUser: data.FPUser,
          PACServices: data.PACServices,
          ReferredTo: data.ReferredTo,
          MstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
          MstUserId: userProfileDatas[0].MstUserId,
          MstRoleId: userProfileDatas[0].MstRoleId,
          MstBranchProjectId: userProfileDatas[0].MstLocationId,
          MstSDPId: bindServicesDatas[rowIndex].MstSDPId,
          MstAreaId: bindServicesDatas[rowIndex].MstAreaId,
          MstORWId:
            userProfileDatas[0].MstRoleId == 7
              ? userProfileDatas[0].MstUserId
              : 0,
          ServicesId: bindServicesDatas[rowIndex].ServicesId,
          Flag: 2,
        };
      }
      return data;
    });

    setBindServicesAddData(updatedTableData);
    setServicesProvideDatas(updatedTableData);

    setServiceData1(doctorAppoinmentDatas);

    const servicesProvideChild = Object.values(bindProvideServicesDatas).filter(
      (item) => item.TxnServicesId === bindServicesDatas[rowIndex].TxnServicesId
    );
    setServiceData2(servicesProvideChild[0]);

    const appointmentWithRowData = doctorAppoinmentDatas;

    let appointmentWithInfo;
    let ResultAppointmentWith = "";
    let ResultEmail = "";

    if (
      appointmentWithRowData.length > 0 &&
      appointmentWithRowData[0].AppointmentWith
    ) {
      const filteredData = getLocationDatas.filter(
        (item) =>
          item.MstLocationId === appointmentWithRowData[0].AppointmentWith
      );
      ResultAppointmentWith = filteredData[0].LocationName_en;
      //  ResultEmail = filteredData[0].Email;
      ResultEmail = doctorAppoinmentDatas[0].AppointmentEmail;

    } else {

    }

    let ResultAppointmentDate = ""; // Default value in case of an empty array or undefined

    if (
      doctorAppoinmentDatas.length > 0 &&
      doctorAppoinmentDatas[0].AppoinmentDate
    ) {
      ResultAppointmentDate = doctorAppoinmentDatas[0].AppoinmentDate;
    } else {
    }

    const appointmentAreaRowData = doctorAppoinmentDatas;
    let appointmentAreaInfo;
    let ResultAppointmentArea = { value: "", label: "" }; // Default values

    if (
      appointmentAreaRowData.length > 0 &&
      appointmentAreaRowData[0].MstAreaId
    ) {
      appointmentAreaInfo = bindAppoinmentAreaDD.find(
        (L) =>
          parseInt(L.value) === parseInt(appointmentAreaRowData[0].MstAreaId)
      );

      ResultAppointmentArea = {
        value: appointmentAreaRowData[0].MstAreaId,
        label: appointmentAreaInfo ? appointmentAreaInfo.label : "Unknown",
      };
    } else {
    }
    var CRSFollowUpPart = bindServicesDatas[rowIndex].CRSFollowUp;
    const CRSFollowUpDate = CRSFollowUpPart
      ? CRSFollowUpPart.split("T")[0]
      : null;

    var ReferralFollowUpPart = bindServicesDatas[rowIndex].ReferralFollowUp;
    const ReferralFollowUpDate = ReferralFollowUpPart
      ? ReferralFollowUpPart.split("T")[0]
      : null;

    const sdpRowData = bindServicesDatas[rowIndex];
    const sdpInfo = bindSDPDD.find((L) => L.value === sdpRowData.MstSDPId);
    const ResultSDP = {
      value: sdpRowData.MstSDPId,
      label: sdpInfo ? sdpInfo.label : "Unknown",
    };

    const areaRowData = bindServicesDatas[rowIndex];

    const areaInfo = bindArea.find((A) => A.value === areaRowData.MstAreaId);
    const ResultArea = {
      value: areaRowData.MstAreaId,
      label: areaInfo ? areaInfo.label : "Unknown",
    };
    // const bindTxnServicesId = bindServicesDatas[rowIndex].TxnServicesId;

    const serviceSubCfilteredData = Object.values(
      bindProvideServicesDatas
    ).filter((item) => item.TxnServicesId === bindTxnServicesId);
    const resultserviceSubC = serviceSubCfilteredData.map(
      (item) => item.MstServicesSubCategoryId
    );

    const serviceNamefilteredData = Object.values(
      bindProvideServicesDatas
    ).filter((item) => item.TxnServicesId === bindTxnServicesId);
    const resultservicesName = serviceNamefilteredData.map(
      (item) => item.MstServicesId
    );

    // const issueMedicineDrugDatas = Object.values(bindMedicineDrugDatas).filter(
    //   (item) => item.TxnServicesId === bindServicesDatas[rowIndex].TxnServicesId
    // );

    setCurrentData1(issueMedicineDrugDatas);
    setCurrentData3(servicesFields.sdp, servicesFields.area);

    setUpDatedTableData(updatedTableData);
    var Date = bindServicesDatas[rowIndex].ServicesDate;
    const formattedDate = Date.split("T")[0];
    const AutoDropdownPopupdata = [
      ResultAppointmentWith,
      CRSFollowUpDate,
      ReferralFollowUpDate,
      ResultSDP,
      ResultArea,
      resultserviceSubC,
      resultservicesName,
      formattedDate,
      ResultEmail,
      ResultAppointmentDate,
    ];

    setPopupdata(AutoDropdownPopupdata);
  };



  // const handleExport = async () => {
  //   
  //   try {
  //     const [profile] = userProfileDatas;

  //     const data = {
  //       mstOrganizationStructureId: profile.MstOrganizationId,
  //       mstBranchId: profile.MstLocationId,
  //       mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
  //       mstUserId: profile.MstUserId,
  //       mstRoleId: profile.MstRoleId,
  //     };
  //     const servicesResponse = await BindPostAPI([data], "TXNServicesAPI/ExcelExportTXNServices");
  //     const rows = servicesResponse?.data?.Table || [];

  //     if (rows.length === 0) {
  //       toast.error("No data available to export", {
  //         duration: 1000,
  //         position: "top-center",
  //       });
  //       return;
  //     }

  //     // ✅ PASS ONLY STRING HEADERS (same as commodities)
  //     exportData(
  //       servicesExcelExportHeader.map((column) => column.title),
  //       rows
  //     );
  //   } catch (error) {
  //     console.error("SDP Excel Export Error:", error);
  //     toast.error("Failed to export SDP data", {
  //       duration: 1000,
  //       position: "top-center",
  //     });
  //   }
  // };


  const handleExport = async () => {


    const createdBy = sessionStorage.getItem("createdBy");

    try {
      const [profile] = userProfileDatas;

      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0,
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
      };

      const servicesResponse = await BindPostAPI(
        [data],
        "TXNServicesAPI/ExcelExportTXNServices"
      );

      const rows = servicesResponse?.data?.Table || [];

      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "TXN SERVICES",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "txn_services",
            description: "No data available to export",
          },
          "Log/IUDLog"
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "TXN SERVICES",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "txn_services",
            description: `TXN Services Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog"
        );
      }

      // ✅ PASS ONLY STRING HEADERS
      exportData(
        servicesExcelExportHeader.map((column) => column.title),
        rows
      );
    } catch (error) {
      console.error("SDP Excel Export Error:", error);

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "TXN SERVICES",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "txn_services",
          description: error?.message || "TXN Services Excel export failed",
        },
        "Log/IUDLog"
      );

      toast.error("Failed to export SDP data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const exportData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Services",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column, // ✅ STRING ONLY
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: baseStyle },               // S.No
        { v: rowData.TxnServicesId, s: baseStyle }, // Country
        { v: rowData.ClientId, s: baseStyle }, // Country
        { v: rowData.ClientName_en, s: baseStyle },
        { v: rowData.ClientName_ta, s: baseStyle },
        { v: rowData.ClientName_hi, s: baseStyle },
        { v: rowData.ClientName_mr, s: baseStyle },
        { v: rowData.ClientName_gu, s: baseStyle },
        { v: rowData.ClientName_kn, s: baseStyle },
        { v: rowData.ClientName_ml, s: baseStyle },
        { v: rowData.ClientName_te, s: baseStyle },
        { v: rowData.ClientName_bn, s: baseStyle },
        { v: rowData.ClientName_or, s: baseStyle },
        { v: rowData.ClientMotherName_en, s: baseStyle },
        { v: rowData.ClientMotherName_ta, s: baseStyle },
        { v: rowData.ClientMotherName_hi, s: baseStyle },
        { v: rowData.ClientMotherName_mr, s: baseStyle },
        { v: rowData.ClientMotherName_gu, s: baseStyle },
        { v: rowData.ClientMotherName_kn, s: baseStyle },
        { v: rowData.ClientMotherName_ml, s: baseStyle },
        { v: rowData.ClientMotherName_te, s: baseStyle },
        { v: rowData.ClientMotherName_bn, s: baseStyle },
        { v: rowData.ClientMotherName_or, s: baseStyle },
        { v: rowData.ClientPhoneNo, s: baseStyle },
        { v: rowData.ServicesDate, s: baseStyle },
        { v: rowData.ReasonForVisit_en, s: baseStyle },
        { v: rowData.ReasonForVisit_ta, s: baseStyle },
        { v: rowData.ReasonForVisit_hi, s: baseStyle },
        { v: rowData.ReasonForVisit_mr, s: baseStyle },
        { v: rowData.ReasonForVisit_gu, s: baseStyle },
        { v: rowData.ReasonForVisit_kn, s: baseStyle },
        { v: rowData.ReasonForVisit_ml, s: baseStyle },
        { v: rowData.ReasonForVisit_te, s: baseStyle },
        { v: rowData.ReasonForVisit_bn, s: baseStyle },
        { v: rowData.ReasonForVisit_or, s: baseStyle },
        { v: rowData.LocationName_en, s: baseStyle },
        { v: rowData.SDP_en, s: baseStyle },
        { v: rowData.AreaName_en, s: baseStyle },
        { v: rowData.ProjectName_en, s: baseStyle },
        { v: rowData.ServicesCategory_en, s: baseStyle },
        { v: rowData.ServicesCategory_ta, s: baseStyle },
        { v: rowData.ServicesCategory_hi, s: baseStyle },
        { v: rowData.ServicesCategory_mr, s: baseStyle },
        { v: rowData.ServicesCategory_gu, s: baseStyle },
        { v: rowData.ServicesCategory_kn, s: baseStyle },
        { v: rowData.ServicesCategory_ml, s: baseStyle },
        { v: rowData.ServicesCategory_te, s: baseStyle },
        { v: rowData.ServicesCategory_bn, s: baseStyle },
        { v: rowData.ServicesCategory_or, s: baseStyle },
        { v: rowData.ServicesSubCategory_en, s: baseStyle },
        { v: rowData.ServicesSubCategory_ta, s: baseStyle },
        { v: rowData.ServicesSubCategory_hi, s: baseStyle },
        { v: rowData.ServicesSubCategory_mr, s: baseStyle },
        { v: rowData.ServicesSubCategory_gu, s: baseStyle },
        { v: rowData.ServicesSubCategory_kn, s: baseStyle },
        { v: rowData.ServicesSubCategory_ml, s: baseStyle },
        { v: rowData.ServicesSubCategory_te, s: baseStyle },
        { v: rowData.ServicesSubCategory_bn, s: baseStyle },
        { v: rowData.ServicesSubCategory_or, s: baseStyle },
        { v: rowData.Services_en, s: baseStyle },
        { v: rowData.Services_ta, s: baseStyle },
        { v: rowData.Services_hi, s: baseStyle },
        { v: rowData.Services_mr, s: baseStyle },
        { v: rowData.Services_gu, s: baseStyle },
        { v: rowData.Services_kn, s: baseStyle },
        { v: rowData.Services_ml, s: baseStyle },
        { v: rowData.Services_te, s: baseStyle },
        { v: rowData.Services_bn, s: baseStyle },
        { v: rowData.Services_or, s: baseStyle },
        { v: rowData.ResultType, s: baseStyle },
        { v: rowData.UOM, s: baseStyle },
        { v: rowData.PACServices_en, s: baseStyle },
        { v: rowData.PACServices_ta, s: baseStyle },
        { v: rowData.PACServices_hi, s: baseStyle },
        { v: rowData.PACServices_mr, s: baseStyle },
        { v: rowData.PACServices_gu, s: baseStyle },
        { v: rowData.PACServices_kn, s: baseStyle },
        { v: rowData.PACServices_ml, s: baseStyle },
        { v: rowData.PACServices_te, s: baseStyle },
        { v: rowData.PACServices_bn, s: baseStyle },
        { v: rowData.PACServices_or, s: baseStyle },
        { v: rowData.Brand_en, s: baseStyle },
        { v: rowData.Brand_ta, s: baseStyle },
        { v: rowData.Brand_hi, s: baseStyle },
        { v: rowData.Brand_mr, s: baseStyle },
        { v: rowData.Brand_gu, s: baseStyle },
        { v: rowData.Brand_kn, s: baseStyle },
        { v: rowData.Brand_ml, s: baseStyle },
        { v: rowData.Brand_te, s: baseStyle },
        { v: rowData.Brand_bn, s: baseStyle },
        { v: rowData.Brand_or, s: baseStyle },
        { v: rowData.Item, s: baseStyle },
        { v: rowData.Charges, s: baseStyle },
        { v: rowData.FPUser, s: baseStyle },
        { v: rowData.ReferredTo_en, s: baseStyle },
        { v: rowData.ReferredTo_ta, s: baseStyle },
        { v: rowData.ReferredTo_hi, s: baseStyle },
        { v: rowData.ReferredTo_mr, s: baseStyle },
        { v: rowData.ReferredTo_gu, s: baseStyle },
        { v: rowData.ReferredTo_kn, s: baseStyle },
        { v: rowData.ReferredTo_ml, s: baseStyle },
        { v: rowData.ReferredTo_te, s: baseStyle },
        { v: rowData.ReferredTo_bn, s: baseStyle },
        { v: rowData.ReferredTo_or, s: baseStyle },
        { v: rowData.CRSFollowUp, s: baseStyle },
        { v: rowData.ReferralFollowUp, s: baseStyle },


        { v: rowData.Remarks_en, s: baseStyle },
        { v: rowData.Remarks_ta, s: baseStyle },
        { v: rowData.Remarks_hi, s: baseStyle },
        { v: rowData.Remarks_mr, s: baseStyle },
        { v: rowData.Remarks_gu, s: baseStyle },
        { v: rowData.Remarks_kn, s: baseStyle },
        { v: rowData.Remarks_ml, s: baseStyle },
        { v: rowData.Remarks_te, s: baseStyle },
        { v: rowData.Remarks_bn, s: baseStyle },
        { v: rowData.Remarks_or, s: baseStyle },
        { v: rowData.CommodityType_en, s: baseStyle },
        { v: rowData.CommodityType_ta, s: baseStyle },
        { v: rowData.CommodityType_hi, s: baseStyle },
        { v: rowData.CommodityType_mr, s: baseStyle },
        { v: rowData.CommodityType_gu, s: baseStyle },
        { v: rowData.CommodityType_kn, s: baseStyle },
        { v: rowData.CommodityType_ml, s: baseStyle },
        { v: rowData.CommodityType_te, s: baseStyle },
        { v: rowData.CommodityType_bn, s: baseStyle },
        { v: rowData.CommodityType_or, s: baseStyle },
        { v: rowData.CommodityCategory_en, s: baseStyle },
        { v: rowData.CommodityCategory_ta, s: baseStyle },
        { v: rowData.CommodityCategory_hi, s: baseStyle },
        { v: rowData.CommodityCategory_mr, s: baseStyle },
        { v: rowData.CommodityCategory_gu, s: baseStyle },
        { v: rowData.CommodityCategory_kn, s: baseStyle },
        { v: rowData.CommodityCategory_ml, s: baseStyle },
        { v: rowData.CommodityCategory_te, s: baseStyle },
        { v: rowData.CommodityCategory_bn, s: baseStyle },
        { v: rowData.CommodityCategory_or, s: baseStyle },
        { v: rowData.CommodityName_en, s: baseStyle },
        { v: rowData.CommodityName_ta, s: baseStyle },
        { v: rowData.CommodityName_hi, s: baseStyle },
        { v: rowData.CommodityName_mr, s: baseStyle },
        { v: rowData.CommodityName_gu, s: baseStyle },
        { v: rowData.CommodityName_kn, s: baseStyle },
        { v: rowData.CommodityName_ml, s: baseStyle },
        { v: rowData.CommodityName_te, s: baseStyle },
        { v: rowData.CommodityName_bn, s: baseStyle },
        { v: rowData.CommodityName_or, s: baseStyle },
        { v: rowData.CommodityBrand_en, s: baseStyle },
        { v: rowData.CommodityBrand_ta, s: baseStyle },
        { v: rowData.CommodityBrand_hi, s: baseStyle },
        { v: rowData.CommodityBrand_mr, s: baseStyle },
        { v: rowData.CommodityBrand_gu, s: baseStyle },
        { v: rowData.CommodityBrand_kn, s: baseStyle },
        { v: rowData.CommodityBrand_ml, s: baseStyle },
        { v: rowData.CommodityBrand_te, s: baseStyle },
        { v: rowData.CommodityBrand_bn, s: baseStyle },
        { v: rowData.CommodityBrand_or, s: baseStyle },


        { v: rowData.Quantity, s: baseStyle },
        { v: rowData.CommodityUOM, s: baseStyle },
        { v: rowData.CommodityCharges, s: baseStyle },
        { v: rowData.AppoinmentDate, s: baseStyle },
        { v: rowData.AppointmentWith_en, s: baseStyle },
        { v: rowData.AppointmentWith_ta, s: baseStyle },
        { v: rowData.AppointmentWith_hi, s: baseStyle },
        { v: rowData.AppointmentWith_mr, s: baseStyle },
        { v: rowData.AppointmentWith_gu, s: baseStyle },
        { v: rowData.AppointmentWith_kn, s: baseStyle },
        { v: rowData.AppointmentWith_ml, s: baseStyle },
        { v: rowData.AppointmentWith_te, s: baseStyle },
        { v: rowData.AppointmentWith_bn, s: baseStyle },
        { v: rowData.AppointmentWith_or, s: baseStyle },
        { v: rowData.Email, s: baseStyle },
        { v: rowData.MeetingLink, s: baseStyle },
        { v: rowData.FullName_en, s: baseStyle },



      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 5 },   // S.No

      { width: 15 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },

      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },

      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },

      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 50 },

      { width: 30 },
      { width: 30 },


    ];

    /* ================= ROW HEIGHTS ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SDP Master");
    XLSX.writeFile(wb, "Services.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        // Client Data grid
        <div>
          <div className={mainTable.headerTitle}>
            <div className={mainTable.gridTableHeader}>{`Services`}</div>
            <hr class="h-px bg-gray-200 border-0"></hr>
          </div>

          <GridPage
            title="Client Data"
            xScroll="overflow-x-auto max-md:w-fit w-full"
            tableScroll="relative z-0 flex flex-col md:block hidden border text-sm text-left text-gray-500 w-full md:min-w-fit"
            header={ServicesClientHeaders}
            records={bindClientDatas}
            addClientView={addClientVisible}
            showAdd={showAdd}
            onHistoryGrid={HandleClientHistory}
          />
          <div>
            <hr class={mainTable.servicesHorizontalLine}></hr>
            <GridPage
              // Services Provided grid
              title="Services Provided"
              xScroll="overflow-x-auto max-md:w-fit w-full"
              tableScroll="relative z-0 flex flex-col md:block hidden border text-sm text-left text-gray-500 w-full md:min-w-fit"
              header={ServicesHeaders}
              handleEdit={handleEdit}
              records={bindServicesDatas}
              handleAction={handleServicesPopup}
              addView={true}
              blockView={true}
              handleExportBtn={true}
              handleExport={handleExport}
            />
          </div>
        </div>
      )}

      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Services"
            />

            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className="h-screen">
                  <div className={mainTable.grid2}>
                    <div className="flex items-center">
                      <label className={mainTable.serviceLabel}>
                        Client Id. : &nbsp;
                      </label>
                      <label className={mainTable.label}>
                        {servicesFields.clientId}
                      </label>
                    </div>
                    <div className="flex items-center">
                      <label className={mainTable.serviceLabel}>
                        Client Name : &nbsp;
                      </label>

                      <Tooltip text={servicesFields.clientName}>
                        <label className={mainTable.label}>{tooltipText}</label>
                      </Tooltip>
                    </div>
                    <div className="flex items-center">
                      <label className={mainTable.serviceLabel}>
                        Mother Name : &nbsp;
                      </label>
                      <label className={mainTable.label}>
                        {servicesFields.motherName}
                      </label>
                    </div>
                    <div className="flex items-center">
                      <label className={mainTable.serviceLabel}>
                        Phone Number : &nbsp;
                      </label>
                      <label className={mainTable.label}>
                        {servicesFields.phoneNumber}
                      </label>
                    </div>
                  </div>
                  <div className="md:grid gap-4 mb-6 md:grid-cols-3 xl:grid-cols-4 sm:col-span-1 w-full">
                    <InputText
                      inputType="date"
                      title="Date"
                      classStar="text-red-500"
                      disabled={updateScreenTitle}
                      name="date"
                      max={new Date().toISOString().split("T")[0]}
                      content={servicesFields.date}
                      controlFunc={(e) =>
                        setServicesFields({
                          ...servicesFields,
                          date: e.target.value,
                        })
                      }
                    />
                    <InputText
                      // classStar="text-red-500"
                      inputType="text"
                      title="Reason For Visit"
                      maxLength={500}
                      name="reasonForVisit"
                      content={servicesFields.reasonForVisit}
                      controlFunc={(e) =>
                        setServicesFields({
                          ...servicesFields,
                          reasonForVisit: e.target.value,
                        })
                      }
                    // controlFuncBlur={() => {
                    //   setServicesFieldsError((servicesFieldsError) => ({
                    //     ...servicesFieldsError,
                    //     reasonForVisitError:
                    //       servicesFields.reasonForVisit &&
                    //         servicesFields.reasonForVisit.length > 0
                    //         ? /^[A-Za-z ]+$/.test(
                    //           servicesFields.reasonForVisit
                    //         )
                    //           ? ""
                    //           : "Only Alphabet and space allowed"
                    //         : "Enter Reason For Visit",
                    //   }));
                    // }}
                    // errorMessage={servicesFieldsError.reasonForVisitError}
                    />
                    <AutoDropDown
                      classStar="text-red-500"
                      title="S.D.P."
                      options={bindUserSDPDD}
                      placeholder="Select"
                      name="sdp"
                      disabled=""
                      selectedOption={bindUserSDPDD.find(
                        (x) => x.value == userProfileDatas[0].MstSDPId ? userProfileDatas[0].MstSDPId : servicesFields.sdp
                      )}
                      controlFunc={(value, e) => {
                        setServicesFields({
                          ...servicesFields,
                          area: "",
                        });
                        handleServicesFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setServicesFieldsError(() => ({
                          ...servicesFieldsError,
                          sdpError: servicesFields.sdp ? "" : "Select S.D.P",
                        }));
                      }}
                      Class="custom-class"
                      tabIndex="1"
                      errorMessage={servicesFieldsError.sdpError}
                      setError={setServicesFieldsError}
                    />
                    <AutoDropDown
                      classStar="text-red-500"
                      title="Area"
                      options={bindAreaDD}
                      placeholder="Select"
                      name="area"
                      selectedOption={
                        servicesFields.area
                          ? bindAreaDD.find(
                            (x) => x.value == servicesFields.area
                          )
                          : ""
                      }
                      controlFunc={(value, e) => {
                        handleServicesFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setServicesFieldsError(() => ({
                          ...servicesFieldsError,
                          areaError: servicesFields.area ? "" : "Select Area",
                        }));
                      }}
                      Class="custom-class"
                      tabIndex="1"
                      errorMessage={servicesFieldsError.areaError}
                      setError={setServicesFieldsError}
                    />
                    <div className="dropdown-container">
                      <DropDown
                        title="Project"
                        options={bindProject}
                        placeholder="Select"
                        name="project"
                        // classStar="text-red-500"
                        selectedOption={servicesFields.project}
                        controlFunc={(e) =>
                          setServicesFields({
                            ...servicesFields,
                            project: e.target.value,
                          })
                        }

                      />

                      {servicesFieldsError.projectError && (
                        <span className="error-message text-red-500">
                          {servicesFieldsError.projectError}
                        </span>
                      )}
                    </div>

                    <div className="dropdown-container">
                      <DropDown
                        title="Service Category"
                        // options={bindServiceCategory}
                        options={
                          servicesFields.clientGender === 1
                            ? bindServiceCategory.filter(
                              (item) => item.value !== 2 && item.value !== 5 && item.value !== 6
                            )
                            : bindServiceCategory
                        }
                        placeholder={"Select"}
                        name="serviceCategory"
                        class="custom-class"
                        classStar="text-red-500"
                        tabIndex="1"
                        selectedOption={servicesFields.serviceCategory}
                        controlFunc={(e) => {
                          setServiceSubCategory("");
                          setServicesFields({
                            ...servicesFields,
                            serviceCategory: e.target.value,
                          });
                        }}
                        controlFuncBlur={() => {
                          setServiceSubCategory("");
                          setServicesFieldsError(() => ({
                            ...servicesFieldsError,
                            serviceCategoryError: servicesFields.serviceCategory
                              ? ""
                              : "Select Service Category",
                          }));
                        }}
                      />

                      {servicesFieldsError.serviceCategoryError && (
                        <span className="error-message text-red-500">
                          {servicesFieldsError.serviceCategoryError}
                        </span>
                      )}
                    </div>
                    <div>
                      <MultiSelect
                        classStar="text-red-500"
                        label="Service Sub-Category"
                        filteredOptions={bindServiceSubCategory}
                        classFilterLabel="p-1 flex gap-1"
                        class="custom-class"
                        placeholder={
                          serviceSubCategory?.length > 0
                            ? "More Selected"
                            : "Select..."
                        }
                        name="ServiceSubCategory"
                        selectedOptions={serviceSubCategory}
                        classDiv="relative w-full inline-block"
                        onChange={(e) => {
                          setServicesName("");
                          servicesSubCategoryChange(e);
                        }}
                        classLabel={mainTable.labelNoWrap}
                      />
                      {serviceSubCategoryError && (
                        <span className="text-red-500">
                          {serviceSubCategoryError}
                        </span>
                      )}
                    </div>
                    <div>
                      <MultiSelect
                        classStar="text-red-500"
                        label="Services"
                        filteredOptions={bindServicesName}
                        classFilterLabel="p-1 flex gap-1"
                        class="custom-class"
                        placeholder={
                          servicesName?.length > 0
                            ? "More Selected"
                            : "Select..."
                        }
                        name="services"
                        selectedOptions={servicesName}
                        classDiv="relative w-full inline-block"
                        onChange={servicesNameChange}
                      />
                      {servicesNameError && (
                        <span className="text-red-500">
                          {servicesNameError}
                        </span>
                      )}
                    </div>
                    <div className="flex justify-center col-span-2 lg:col-span-4 md:col-span-4">
                      <div className={mainTable.grid2}>
                        <button
                          data-modal-hide="bottom-right-modal"
                          type="button"
                          className={mainTable.goButton}
                          disabled={handleGoBtn}
                          onClick={() => HandleGo()}
                        >
                          GO
                        </button>
                        <button
                          data-modal-hide="bottom-right-modal"
                          type="button"
                          className={mainTable.backButton}
                          onClick={() => cancel()}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>

                  {visibleServicesAdd && (
                    <div>
                      <div>
                        <hr class={mainTable.servicesHorizontalLine}></hr>
                        <GridPage
                          header={ServicesAddHeader}
                          records={bindServicesAddData}
                          bindReferralDD={bindReferralDD}
                          handleAction={HandleDelete}
                          onReferralGrid={handleReferralChange}
                          rowsPerPageView={true}
                          onFPUserDD={bindFPUserDD}
                          onTestResultTypeDD={bindTestResultTypeDD}
                          onTestResultType5DD={bindTestResultType5DD}
                          addView={true}
                          bindPACServicesDD={bindPACServices}
                          onServicesProvide={handleServicesProvide}
                          xScroll="overflow-x-auto max-md:w-fit w-full"
                          tableScroll="relative z-0 flex flex-col md:block hidden border text-sm text-left text-black w-full md:min-w-fit"
                        />

                        <hr class={mainTable.servicesHorizontalLine}></hr>
                        <div className={mainTable.grid2}>
                          <InputText
                            inputType="date"
                            title=" Contraceptive renewal supply follow up"
                            name="renewalDate"
                            content={servicesFields.renewalDate}
                            controlFunc={(e) =>
                              setServicesFields({
                                ...servicesFields,
                                renewalDate: e.target.value,
                              })
                            }
                          />
                          <InputText
                            inputType="date"
                            title="Referral follow up"
                            name="Referral follow up"
                            content={servicesFields.referralfollowupDate}
                            controlFunc={(e) =>
                              setServicesFields({
                                ...servicesFields,
                                referralfollowupDate: e.target.value,
                              })
                            }
                          />
                        </div>
                        <hr class={mainTable.servicesHorizontalLine}></hr>
                        <div class={"my-6"}>
                          <TextArea
                            inputType="text"
                            title="Diagnosis / Remarks"
                            name="specificHistory"
                            rows={4}
                            maxLength={500}
                            content={servicesFields.servicesRemark}
                            placeholder="Typing"
                            controlFunc={(e) =>
                              setServicesFields({
                                ...servicesFields,
                                servicesRemark: e.target.value,
                              })
                            }
                          />
                        </div>

                        <div className="grid gap-4 mb-6 md:grid-cols-2 sm:col-span-1">
                          <input
                            type="button"
                            className={mainTable.submitButton}
                            value="Medicine / Commodities"
                            onClick={HandleCommodities}
                          />

                          <input
                            type="button"
                            className={mainTable.submitButton}
                            value="Doctor Appointment"
                            onClick={HandleAppoinment}
                          />
                        </div>
                      </div>
                      <div>
                        <hr class={mainTable.servicesHorizontalLine}></hr>

                        <GridPage
                          title="History"
                          header={ServicesHeadersData}
                          records={bindServicesHistroyData}
                          onServicesGrid={HandleServicesHistory}
                          addView={true}
                        />
                      </div>
                      <Buttons
                        addScreenTitle={addScreenTitle}
                        updateScreenTitle={updateScreenTitle}
                        handleSubmit={handleSubmit}
                        cancel={cancel}
                        disabledBtn={submitBtnDisabled ? true : false}
                      />
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleServicesPopup}
      >
        <div>
          <PopUpScreenTitle
            title="Services"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <AddServices
            data={serviceDatas}
            data1={serviceDatas1}
            data2={popupdata}
            data3={serviceDatas2}
            currentData1={currentData1}
            upDatedTableData={upDatedTableData}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>

      <MainPopup
        popUpOpen={servicesHistorypopUpOpen}
        setpopUpOpen={setServicesHistorypopUpOpen}
        Open={() => HandleServicesHistory}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <AddServices
            data={serviceDatas}
            data1={serviceDatas1}
            data2={popupdata}
            data3={serviceDatas2}
            currentData1={currentData1}
            upDatedTableData={upDatedTableData}
          />
        </div>
        <PopUpButtons cancel={cancel1} />
      </MainPopup>

      <MainPopup
        popUpOpen={clientHistorypopUpOpen}
        setpopUpOpen={setClientHistorypopUpOpen}
        Open={() => HandleClientHistory}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <ClientHistory data={serviceDatas} data1={clientHistoryPopupClear} />
        </div>
        <PopUpButtons cancel={cancel1} />
      </MainPopup>

      <MainPopup
        popUpOpen={commoditiespopUpOpen}
        setpopUpOpen={setCommoditiespopUpOpen}
        Open={() => HandleCommodities}
        notificationPopups={notificationDesign}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <IssueOfCommodity
            isOpen={setCommoditiespopUpOpen}
            data1={handleIssueCommodity}
            currentData1={currentData1}
            currentData2={currentData3}
            issuePopupCancel={issuePopupCancel}
          />
        </div>
        <div className={mainTable.submitCancelMainDiv}></div>
      </MainPopup>

      <MainPopup
        popUpOpen={appoinmentpopUpOpen}
        setpopUpOpen={setAppoinmentpopUpOpen}
        Open={() => HandleAppoinment}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <DoctorAppoinment
            isOpen={setAppoinmentpopUpOpen}
            data1={handleDoctorAppoinment}
            clientData={location1?.state?.isData}
            currentData2={currentData2}
            doctorPopupCancel={doctorPopupCancel}
          />
        </div>
      </MainPopup>
    </MainLayout>
  );
}

export default Services;
